import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { MenuItem as PrimeMenuItem } from "primeng/api";
import { GenericMenuComponent } from "../generic-menu-component.model";
import { MenuItem } from "../menu-item.model";
import { MenuService } from "../menu.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent extends GenericMenuComponent implements OnChanges, OnDestroy {
  @Input() items: MenuItem[] = [];
  @Input() isMemberMenu = false;
  @Input() menuTitle = "";

  currentItems: MenuItem[] = [];

  // Cached PrimeNG model, rebuilt ONLY when `items` actually changes (in ngOnChanges).
  // Previously this was a `get currentMenuItems()` getter that called toPrimeMenuItems() on every
  // change-detection pass, returning a brand-new array/objects/closures each time. Bound to
  // <p-menu [model]="currentMenuItems">, that fed PrimeNG a new reference every tick, which
  // re-dirtied the view and caused an infinite change-detection loop -> hard main-thread freeze
  // on every navigation (dev mode). Caching gives a stable reference between item changes.
  currentMenuItems: PrimeMenuItem[] = [];

  constructor(private menuService: MenuService) { super(); }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items) {
      this.currentItems = changes.items.currentValue || [];
      this.currentMenuItems = this.toPrimeMenuItems(this.currentItems);

      if (changes.items.isFirstChange()) { return; }

      if (changes.items.currentValue !== changes.items.previousValue) {
        this.refresh = true;
      }
    }
  }

  ngOnDestroy(): void {}

  trackByIndex(index: number): number {
    return index;
  }

  closeSubMenu(): void {
    this.menuService.toggleMenuState(false);
  }

  navigateExternal(path: string): void {
    window.location.href = path;
  }
}
